import { render, staticRenderFns } from "./Investor.vue?vue&type=template&id=4ddfbeb4&"
import script from "./Investor.vue?vue&type=script&lang=ts&"
export * from "./Investor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports